// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
// export const environment = {
//   BASE_URL: 'http://localhost:8080/',
//   LOGIN_URL: 'http://localhost:8800/',
//   METRIC_VALUES_URL: `${'https://dev.intellija.com/' + 'gql/'}v1/graphql`,
//   REST_BASE_URL: ' https://dev.intellija.com/config/api/v1/',
//   production: false,
//   hmr: false,
//   staging: false,
//   POLL_RATE: 5000
// };

export const environment = {
  BASE_URL: 'https://dev.iotechglobal.io/',
  LOGIN_URL: 'https://dev.iotechglobal.io/',
  METRIC_VALUES_URL: `${'https://dev.iotechglobal.io/' + 'gql/'}v1/graphql`,
  REST_BASE_URL: ' https://dev.iotechglobal.io/config/api/v1/',
  development: true,
  production: true,
  hmr: false,
  staging: false,
  demo: false,
  POLL_RATE: 10000,
  MAP_BOX_TOKEN: 'pk.eyJ1IjoidW1haXJraGF0cmkiLCJhIjoiY2w3c3RnNHRyMHJ2YTN0bzBvcHhvNWNjOSJ9.PnFz3VkzqSOaTtplDcWLbw'
 };
